import { router, Stack, useLocalSearchParams } from 'expo-router';
import React from 'react';
import { Platform, View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { useCustomer } from '@/api/customers/use-customer';
import { useReservation } from '@/api/reservations/use-reservation';
import { findAdditionalDriver } from '@/components/additional-drivers/status';
import BackButton from '@/components/back-button';
import VerifyLicense from '@/components/verify-license';

export default function VerifyLicenseScreen() {
  const { styles, theme } = useStyles(stylesheet);
  const { trip_id, reverify } = useLocalSearchParams();

  const { data: customer, isFetching: isFetchingCustomer } = useCustomer();

  const {
    data: resData,
    isPending: isFetchingReservation,
    refetch,
  } = useReservation({
    //@ts-ignore
    variables: { id: trip_id },
    enabled: !!trip_id,
  });

  const additionalDriver = React.useMemo(() => {
    if (!customer || !resData) return null;

    return findAdditionalDriver(resData?.additionalDrivers, customer);
  }, [resData, customer]);

  return (
    <View style={styles.container}>
      {Platform.OS === 'web' &&
      ['md', 'lg'].includes(UnistylesRuntime.breakpoint) ? (
        <Stack.Screen
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          options={{
            title: "Verify Your Driver's License",
            headerTitle: "Verify Your Driver's License",
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (trip_id) {
                    if (reverify) {
                      router.navigate(`/trips/${trip_id}/checkin`);
                      return;
                    }

                    if (
                      additionalDriver &&
                      (!additionalDriver.setupComplete ||
                        additionalDriver.driversLicenseStatus !== 'approved')
                    ) {
                      router.navigate(
                        `/trips/${trip_id}/additional-drivers/verify`
                      );
                      return;
                    }

                    router.navigate(`/trips/${trip_id}/details`);
                  } else {
                    router.navigate('/trips');
                  }
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleStyle: {
              fontSize: 17,
            },
          }}
        />
      )}

      <VerifyLicense />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background_1,
  },
}));
